<!-- Banner de Google Ads -->
<div *ngIf="!isLoggedIn" id='div-gpt-ad-1694399862191-0' class="commercial-banner"></div>

<footer>
    <div class="row custom-container">
        <div class="col-12 col-md-5">
            <div class="footer-search">
                <div class="logo-footer">
                    <img class="border-r pe-2" src="../../../assets/images/logos/logo_midc_white.svg"
                        alt="Midatacrédito, consulta tu historia de crédito" title="Logo midatacrédito">
                    <a (click)="clic_footer_download_app()"
                        href="https://play.google.com/store/apps/details?id=com.midatacredito" target="_blank"
                        rel="noopener">
                        <img src="../../../assets/images/logos/Logo_PlayStore_Blanco.svg" alt="Descargar en Google Play"
                            title="Logo Android">
                    </a>
                    <a (click)="clic_footer_download_app()"
                        href="https://apps.apple.com/co/app/midatacredito/id6752889575?utm_source=midatacredito&utm_medium=footer&utm_campaign=descarga_app_ios_footer"
                        target="_blank" rel="noopener">
                        <img src="../../../assets/images/logos/Icono_AppStore.svg" alt="Descargar en App Store"
                            title="Logo iOS">
                    </a>
                    <div class="social">
                        <p>Encuéntranos en:</p>
                        <a id="social_Facebook" target="_blank" href="https://www.facebook.com/midatacreditoficial"><img
                                src="assets/images/icons/Facebook_Icono.svg" alt="Facebook Icono"></a>
                        <a id="social_Instagram" target="_blank"
                            href="https://www.instagram.com/midatacredito_oficial/"><img
                                src="assets/images/icons/Instagram_Icono.svg" alt="Instagram Icono"></a>
                        <a id="social_Tiktok" target="_blank" href="https://www.tiktok.com/@midatacredito.com"><img
                                src="assets/images/icons/Tiktok_Icono.svg" alt="Tiktok Icono"></a>
                        <a id="social_X" target="_blank" href="https://x.com/Midatacredito"><img
                                src="assets/images/icons/X_Icono.svg" alt="X Icono"></a>
                        <a id="social_Youtube" target="_blank"
                            href="https://www.youtube.com/@midatacredito_oficial"><img
                                src="assets/images/icons/Youtube_Icono.svg" alt="Youtube Icono"></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-2">
            <div class="footer-links">
                <div class="head-links" (click)="showBodylinks(0)">
                    <p>Nuestras soluciones</p>
                    <i class="fa fa-plus"></i>
                </div>
                <div class="body-links">
                    <div class="box-link" (click)="clic_footer_menu('Buscacredito')">
                        <a [href]="linkDcWithUtms" rel="noopener" target="_blank">Buscacrédito</a>
                    </div>
                    <div class="box-link" (click)="clic_footer_menu('Verifica')">
                        <a href="https://www.midatacredito.com/verifica/?utm_source=MIDC&utm_medium=footer&utm_campaign=boton_verifica"
                            rel="noopener" target="_blank">Verifica</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-2">
            <div class="footer-links">
                <div class="head-links" (click)="showBodylinks(1)">
                    <p>Legal</p>
                    <i class="fa fa-plus"></i>
                </div>
                <div class="body-links">
                    <div class="box-link" (click)="clic_footer_menu('Política de privacidad')">
                        <a href="{{url_politica_privacidad}}" target="_blank">Política de privacidad</a>
                    </div>
                    <div class="box-link" (click)="clic_footer_menu('Términos y condiciones')">
                        <a href="{{url_terminos_condiciones}}" target="_blank">Términos y condiciones</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-2">
            <div class="footer-links">
                <div class="head-links" (click)="showBodylinks(2)">
                    <p>Contáctanos</p>
                    <i class="fa fa-plus"></i>
                </div>
                <div class="body-links">
                    <div class="box-link" (click)="clic_footer_menu('Preguntas frecuentes')">
                        <a routerLink="/faq" target="_self">Preguntas frecuentes</a>
                    </div>
                    <div class="box-link" (click)="irServicioCliente(); clic_footer_menu('Servicio al cliente')">
                        <a target="_self">Servicio al cliente</a>
                    </div>
                    <div class="box-link" (click)="clic_footer_menu('Blog')">
                        <a routerLink="/blog" rel="noopener">Blog</a>
                    </div>
                </div>
            </div>
        </div>
        <hr />
    </div>
    <div class="row custom-container align-items-center">
        <div class="col-md-6 col-12 order-md-1 order-2">
            <div class="copyright">
                <p>{{anio}} <b>Experian Colombia S.A.</b> © Derechos reservados.<br />
                    NIT 900.422.614-8.<br />
                    Carrera 7 No. 76 – 35 Bogotá D.C., Colombia.<br />
                    Email: servicioalciudadano&#64;experian.com</p>
            </div>
        </div>
        <div class="col-md-6 col-12 order-md-2 order-1">
            <div class="copyright">
                <div class="images-copyright">
                    <img src="../../../assets/images/logos/logo-copy.svg" alt="Datacrédito Experian"
                        title="Datacrédito Experian">
                    <p class="sic">VIGILADO</p>
                    <a href="https://www.sic.gov.co/" target="_blank" rel="noopener">
                        <img src="../../../assets/images/logos/logo_SIC_blanco.png"
                            alt="Superintendencia de industria y comercio" title="Logo SIC">
                    </a>
                    <img class="iq-logo" src="../../../assets/images/logos/iq_blanco.png"
                        alt="IQ seguridad en pagos digitales" title="IQ">
                </div>
            </div>
        </div>
        <p class="version">V.a13-4.6</p>
    </div>
    <div class="custom-container disclaimer" *ngIf="showDisclaimer">
        <hr />
        <p>&#185; Impacto de Midatacrédito en la vida financiera de los Colombianos. Muestra estadística de <b>más de
                5.000</b> usuarios activos en el portal que respondieron la encuesta.</p>
        <p>&#178; Todas las funcionalidades expuestas en esa sección, son <b>funcionalidades pagas</b> y las puedes
            adquirir comprando una <b>suscripción</b> desde el portal web.</p>
        <p>&#179; Experian <b>no origina créditos</b> ni asume <b>responsabilidad</b> por la aprobación o rechazo de
            créditos ofrecidos por entidades financieras y Fintech.</p>
    </div>
</footer>